import { useModal } from '~/composables/components/modal'

// isOpen は全 CommonsModal 共有の module-level singleton。開いたまま実ナビゲーション
// (OS/ブラウザ戻る含む)で離脱すると、遷移先で isOpen=true と body.modal-open が残置し
// ページ全体が overflow:hidden でスクロール不能になる。実際にページが変わる遷移でのみ
// close() してロックを解除する。
//
// 「同一ページかどうか」は route の同一性(name + params)で判定する。path 文字列比較だと
// router の strict:false により末尾スラッシュの有無で to.path と from.path が食い違い
// (例: from '/me/order/history/' → to '/me/order/history')、同一ページ内で query を更新する
// だけの経路(会計履歴の明細モーダル等)でも close() が誤発火してしまう。name + params が
// 一致すれば同一ページとみなし、query/hash・末尾スラッシュのみの変化では close() しない。
// 同一ページ内の v-if 兄弟モーダル差し替えは route 変化を伴わないため元より発火しない。
export default defineNuxtPlugin(() => {
  const router = useRouter()
  router.afterEach((to, from) => {
    const samePage =
      to.name === from.name && JSON.stringify(to.params) === JSON.stringify(from.params)
    if (!samePage) useModal().close()
  })
})
